export default "__VITE_ASSET__bfc0fdf6__"